export default __webpack_public_path__ + "static/loss_travel-d7dc94940b81e6c5c2e868a9f4101d67.mp4";